import { useRouter } from 'next/router';
import usePaging from '~/features/ProductList/hooks/usePaging';
import { useTranslations } from '~/services/umbraco/hooks';
import { useConfig } from '~/shared/hooks';
import { Text } from '../Text';
import { Container, PagingLink } from './styled';

type Props = {
    total: number | undefined;
    taken: number | undefined;
    isLoading: boolean;
};

export default function Pagination({ total = 0, taken = 0, isLoading }: Props) {
    const { pathname, query } = useRouter();
    const { translate } = useTranslations();
    const [page] = usePaging();
    const { PRODUCTS_PER_PAGE } = useConfig();
    const nextCount = taken + PRODUCTS_PER_PAGE >= total ? total - taken : PRODUCTS_PER_PAGE;
    const hasNextPage = taken < total;

    return (
        <Container>
            <PagingLink
                href={{
                    pathname,
                    query: {
                        ...query,
                        page: page + 1,
                    },
                }}
                shallow
                scroll={false}
                isLoading={isLoading && hasNextPage}
                noIcon
                hasNextPage={hasNextPage}
            >
                {nextCount > 1
                    ? translate('product-list.pagingButton').replace('[COUNT]', String(nextCount))
                    : translate('product-list.pagingButtonSingle')}
            </PagingLink>

            <Text>
                {translate('product-list.pagingSummary')
                    .replace('[TAKEN]', String(taken))
                    .replace('[TOTAL]', String(total))}
            </Text>
        </Container>
    );
}
